import { render, staticRenderFns } from "./add-participant-form.vue?vue&type=template&id=b77fd0b0"
import script from "./add-participant-form.vue?vue&type=script&lang=js"
export * from "./add-participant-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports